interface ThreadEntry {
  __typename: string
  title?: string
  [key: string]: unknown
}

export const getThreadSubject = (thread: {
  entries: ThreadEntry[]
}): string => {
  const entry = thread.entries.find(
    (e) =>
      (e.__typename === 'OutgoingEmailMessage' ||
        e.__typename === 'IncomingEmailMessage' ||
        e.__typename === 'ManualEmailConversation') &&
      typeof e.title === 'string'
  )
  return entry?.title ?? ''
}
